export default function() {
  window.addEventListener("load", function() {
    document
      .querySelectorAll(
        ".home-speaker-carousel div.speaker-container .speaker-bubble"
      )
      .forEach(function(elem) {
        elem.style.top = "-" + (elem.offsetHeight + 33) + "px !important";
      });

    // let mwMainContainer = document.querySelector(".mw-main-container");
    // if (mwMainContainer) {
    //   mwMainContainer.style.height = mwMainContainer.clientHeight - 126 + "px";
    //   if (mwMainContainer.children) {
    //     Array.from(mwMainContainer.children).forEach(function(elem) {
    //       elem.style.height = elem.clientHeight - 126 + "px";
    //     });
    //   }
    // }

    //onmouseover="bigImg(this)" onmouseout="normalImg(this)"
    let carouselControls = document.querySelector(".home-speaker-controls");
    document.querySelectorAll(".slick-slide").forEach(function(elem) {
      if (elem) {
        elem.addEventListener("mouseover", function(e) {
          if (carouselControls) {
            carouselControls.style.zIndex = 0;
          }
        });
        elem.addEventListener("mouseout", function(e) {
          if (carouselControls) {
            carouselControls.style.zIndex = 99;
          }
        });
      }
    });

    if (!window.matchMedia("(max-width: 767px)").matches) {
      document
        .querySelectorAll(`[class*="illustration-container--"]`)
        .forEach(function(elem) {
          const list = [...elem.classList];
          const value = list
            .find((x) => x.includes("illustration-container--"))
            .split("--")[1];
          if (value) {
            const illustration = elem.querySelector("img");
            elem.style.height =
            illustration.clientHeight - (90) + "px";
            illustration.style.top = '-90px';
            illustration.style.position = "absolute";
          }
        });

      document
        .querySelectorAll(`[class*="overlap-content--"]`)
        .forEach(function(elem) {
          const list = [...elem.classList];
          const value = list
            .find((x) => x.includes("overlap-content--"))
            .split("--")[1];
          if (value) {
            const content = elem.querySelector("div.overlap-me");
            if (content && window.matchMedia("(min-width: 1200px)").matches) {
              elem.style.height =
                content.clientHeight * ((100 - value) / 100) + "px";
              content.style.top = `-${content.clientHeight * (value / 100)}px`;
              content.style.position = "absolute";
            }
          }
        });
    }
  });
}



// WEBPACK FOOTER //
// ./src/js/partials/homepage.js